export default {
  triadList: "Lista de trinomios",
  triadTrainingList: "Lista de trinomios por ",
  promotion: "promoción | promociones",
  youHaveAccess: "Actualmente tiene acceso a {number} {label} {active} {filtered}",
  filtered: "resultados filtrados",
  female_active: "activa | activas",
  male_active: "activo | activos",
  female_archived: "archivada | archivadas",
  male_archived: "archivado | archivados",
  loadingTriads: "Carga de trinomios en curso...",
  homeTriad: "Inicio trinomio",
  apprenticeShort: "A",
  tutorShort: "TP",
  apprenticeMasterShort: "ME",
  companyShort: "EMP",
  Apprentice: "Alumno en prácticas",
  Tutor: "Tutor",
  "Apprentice master": "Mentor",
  "Apprentice master 2": "Mentor 2",
  "Company manager": "Gestor de empresa",
  Parent: "Padre",
  "Studea manager": "Responsable del cuaderno",
  apprentices: "Alumnos en prácticas",
  tutors: "Tutores",
  apprenticeMasters: "Mentores",
  studeaManagers: "Responsables de cuaderno",
  map: "Mentor",
  myContract: "Mi contrato",
  myContacts: "Mis contactos",
  myContracts: "Mis contratos",
  myRegistrationSheet: "Mis fichas de preinscripción",
  help: "Ayuda online",
  company: "Empresa",
  pedagogic_tutor: "Tutor pedagógico",
  company_tutor: "Tutor de empresa",
  apprentice: "Alumno en prácticas",
  tutor: "Tutor",
  apprenticeMaster: "Mentor",
  secondary_apprenticeMaster: "Mentor secundario",
  studeaManager: "Responsable del cuaderno",
  legal_responsible: "Responsable legal",
  studea_ok: "Cuaderno importados",
  triad_not_ok: "Trinomios no importados",
  mission_goal: "Misión y objetivos",
  sso: {
    click_here: "haga clic aquí para acceder a su cuenta",
    other_profile: "Para cualquier otro perfil, introduzca su nombre de usuario en el campo siguiente.",
  },
  contract: {
    rupture: {
      title: "Incumplimiento de contrato",
      title_short: "Incumplimiento",
      waiting_approuval: "Ruptura del contrato en espera de validación",
      declaration_title: "Declaración de incumplimiento de contrato",
      declaration_title_short: "Declaración de incumplimiento",
      add: "Declarar una fecha de rescisión",
      add_short: "Declarar una rescisión",
      modify_short: "Modificar esta incumplimiento",
      modify: "Modificar esta incumplimiento de contrato",
      see: "Consulte los detalles del incumplimiento de contrato",
      see_short: "Detalles del incumplimiento",
      download_rupture_model: "Descargar el modelo de incumplimiento de contrato",
      declare_at_by: ({ named }) => `Declarada el ${named("date")} por ${named("user")}`,
      to_valid: "Termination to validate",
      delete: {
        title: "Cancelar esta rescisión de contrato",
        confirm: "¿Está seguro de que desea cancelar esta rescisión de contrato?",
        success: "¡Rescisión de contrato cancelada con éxito!",
      },
    },
    dropped_out: {
      title: "Este trinomio ha abandonado la formación el",
      reason: "Motivo :",
      comment: "Comentario :",
      declaration_title: "Declarar un abandono de la formación",
      reasons: {
        1: "Reorientación hacia otra trayectoria",
        2: "Abandono del proyecto de formación",
        3: "Casos de fuerza mayor (enfermedad, fallecimiento, etc.)",
        4: "Otros",
      },
      cancel: {
        title: "Cancelar el abandono",
        confirm: "¿Está seguro de que desea cancelar este abandono?",
        success: "¡Abandono cancelado con éxito!",
      },
      seeking_new_contract: "Buscando un nuevo contrato",
      signed_new_contract: "Nuevo contrato firmado",
      graduation: "Graduación",
    },
    more: "información",
    empty_date: "No hay fecha indicada para este contrato",
    list: ({ named }) => `Lista de contratos de : ${named("apprentice")}`,
    livret_not_active: "El cuaderno aún no ha sido activado para esta promoción",
    livret_deactivate_confirm:
      "El cuaderno dejará de estar accesible para el alumno en prácticas y los demás miembros del trinomio hasta que se reactive. ¿Confirmar la desactivación?",
    livret_deactivate_success: "El cuaderno se ha desactivado correctamente",
    livret_activate_success: "El cuaderno se ha activado correctamente",
  },
  secondary_user: {
    list: "Lista de usuarios secundarios",
    filtered: "resultados filtrados",
  },
  change_year: "Acceder al registro anual :",
};
